/** Microsoft Dynamics 365 ERP adapter — STUB. Implements ERPPort. */
export function createDynamicsERP() {
  const err = () => { throw new Error("DYNAMICS_ERP_NOT_IMPLEMENTED"); };
  return {
    async status() { return { status: "not_connected", vendor: "dynamics" }; },
    async listInvoicesForActor() { err(); },
    async listCatalog() { err(); },
    async createQuote() { err(); },
    async createOrder() { err(); },
  };
}
